// extracted by mini-css-extract-plugin
export default {"iframe":"iframe__q3H9p","wrapper":"wrapper__jrcef","main":"main__-y7PE","block":"block__msX3y","blockNum":"blockNum__NTVgy","blockBtn":"blockBtn__wciyX","navBtn":"navBtn__w5hJs"};